import { selectArticleTitle } from './editorSelectors';
import { createSelector } from 'reselect';
import { selectCurrentInstance } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { selectHasArticleWritePermission } from '../../auth/selectors/auth';
export const getSaveData = createSelector([selectCurrentInstance], currentInstance => currentInstance);
export const getHasPermissionToSave = createSelector([selectHasArticleWritePermission], hasArticleWritePermission => hasArticleWritePermission);
export const getCanSave = createSelector([getHasPermissionToSave, selectArticleTitle], (hasPermissionToSave, articleTitle) => {
  return hasPermissionToSave && !!articleTitle;
});